import { render, staticRenderFns } from "./BlogCategoryForm.vue?vue&type=template&id=fc5a5c60&"
import script from "./BlogCategoryForm.vue?vue&type=script&lang=js&"
export * from "./BlogCategoryForm.vue?vue&type=script&lang=js&"
import style0 from "./BlogCategoryForm.vue?vue&type=style&index=0&id=fc5a5c60&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports